import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";

export class TextEditableField extends IEditableField {
    public static instance = getEditableFieldConfiguration(
        require('./text-editable-field.html'),
        [TextEditableField]
    );


}